module.exports = __webpack_public_path__ + "img/06.c1ed5b7f.jpg";